import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { AppState } from '../../app/state/AppState';
import * as Layout from '../../common/styles/Layout';
import { classNames } from '../../common/styles/Utils';
import { requestContentSlice } from '../actions/RequestContentSliceAction';
import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentType } from '../models/ContentType';
import { PageType } from '../models/PageType';
import { SearchResultItem, SearchResultList } from '../models/SearchResultTypes';
import { SingleContentTypeResultStyles } from '../styles/SearchResultPageStyles';
import { NoResultPage } from './NoResultPage';
import { ConnectedResultListWrapper } from './ResultListWrapper';

// eslint-disable-next-line prettier/prettier
export interface SingleContentTypeResultPageOwnProps { }

export type SingleContentTypeResultPageProps = SingleContentTypeResultPageOwnProps &
  SingleContentTypeResultPageStateProps &
  SingleContentTypeResultPageDispatchProps;

export const HeaderTestID = 'Header';

export const InitialContentSliceMaxSize = 10;

export function SingleContentTypeResultPage(props: SingleContentTypeResultPageProps): JSX.Element {
  if (!props.searchResult && props.contentType && ContentDefinitions[props.contentType]) {
    props.requestContentSlice(0, InitialContentSliceMaxSize, props.contentType);
  }

  return props.contentType && ContentDefinitions[props.contentType] ? (
    props.searchResult ? (
      props.searchResult.totalCount > 0 ? (
        <div className={classNames(SingleContentTypeResultStyles, Layout.absolute, Layout.fulfill, Layout.flexV)}>
          <div className={classNames(Layout.flexAuto, Layout.relative)} data-tb-test-id={HeaderTestID}>
            <ConnectedResultListWrapper
              contentType={props.contentType as ContentType}
              pageType={PageType.single}
              items={props.searchResult.list}
            />
          </div>
        </div>
      ) : (
        <NoResultPage />
      )
    ) : (
      <div className={classNames(SingleContentTypeResultStyles)}>
        <div data-tb-test-id={HeaderTestID}>
          <div>Loading...</div>
          {
            // TBD: implement the loading UI here.
          }
        </div>
      </div>
    )
  ) : (
    <></>
  );
}

export interface SingleContentTypeResultPageStateProps {
  searchResult?: SearchResultList<SearchResultItem>;
  contentType?: ContentType;
}

const mapStateToProps = (state: AppState) => {
  return {
    searchResult: state.singleContentType.searchResults,
    contentType: state.search.selectedContentTypeFilterValue as ContentType,
  };
};

export interface SingleContentTypeResultPageDispatchProps {
  readonly requestContentSlice: (offset: number, count: number, contentType: ContentType) => void;
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      requestContentSlice,
    },
    dispatch
  );

export const ConnectedSingleContentTypeResultPage: React.ComponentClass<SingleContentTypeResultPageOwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleContentTypeResultPage);
